(function (window, $) {

	$(function () {
		$(document).on('click', '.js-menu-item-show-more', function () {
			var $li = $(this).closest('li');
			var $ul = $li.closest('ul');

			$ul.find('li:hidden').show();
			$li.hide();
		});
	});

})(window, jQuery);